<div class="status-dashboard" role="main">
  @if (loading) {
    <div class="skeleton-container" aria-busy="true">
      <div class="skeleton-hero"></div>
      <div class="skeleton-list">
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
      </div>  
    </div>
  }

  @if (error && !loading) {
    <div class="error-state" role="alert">
      <div class="error-icon">
        <span class="e-icons icon-close"></span>
      </div>
      <h3>{{ 'i18n.domain.status-dashboard.error.title' | translate }}</h3>
      <p>{{ 'i18n.domain.status-dashboard.error.message' | translate }}</p>
      <button type="button" class="btn-retry" (click)="retry()">
        {{ 'i18n.domain.status-dashboard.error.retry' | translate }}
      </button>
    </div>
  }

  @if (!loading && !error) {
    <header class="dashboard-header">
      <h2>{{ 'i18n.domain.status-dashboard.title' | translate }}</h2>
    </header>

    <div class="overall-status-card" [class]="'overall-status-card ' + overallStatusClass"
         role="status" aria-live="polite">
      <div class="overall-status-indicator">
        <div class="status-dot-ring">
          @if (overallStatus === ServiceStatusLevel.Operational) {
            <span class="e-icons icon-checkmark"></span>
          } @else if (overallStatus === ServiceStatusLevel.Degraded) {
            <span class="e-icons icon-warning"></span>
          } @else {
            <span class="e-icons icon-close"></span>
          }
        </div>
      </div>
      <div class="overall-status-content">
        <div class="overall-status-text">
          {{ overallStatusKey | translate }}
        </div>
        @if (services.length > 0) {
          <div class="overall-status-summary">
            <span class="summary-item summary-operational">{{ operationalCount }} {{ 'i18n.domain.status-dashboard.summary.operational' | translate }}</span>
            @if (degradedCount > 0) {
              <span class="summary-separator">&middot;</span>
              <span class="summary-item summary-degraded">{{ degradedCount }} {{ 'i18n.domain.status-dashboard.summary.degraded' | translate }}</span>
            }
            @if (downCount > 0) {
              <span class="summary-separator">&middot;</span>
              <span class="summary-item summary-down">{{ downCount }} {{ 'i18n.domain.status-dashboard.summary.down' | translate }}</span>
            }
          </div>
        }
      </div>
    </div>

    <div class="services-section">
      <h3 class="services-heading">{{ 'i18n.domain.status-dashboard.services-heading' | translate }}</h3>
      <div class="services-list">
        @for (service of sortedServices; track service.id) {
          <article class="service-card"
                   [class.service-down]="service.effectiveStatus === ServiceStatusLevel.Down"
                   [class.service-degraded]="service.effectiveStatus === ServiceStatusLevel.Degraded"
                   [class.service-operational]="service.effectiveStatus === ServiceStatusLevel.Operational">
            <div class="service-info">
              <div class="service-name">{{ service.name }}</div>
              @if (service.description) {
                <div class="service-description">{{ service.description }}</div>
              }
              @if (service.reasons && service.reasons.length > 0) {
                <ul class="service-reasons">
                  @for (reason of service.reasons; track reason) {
                    <li>{{ reason }}</li>
                  }
                </ul>
              }
            </div>
            <div class="service-status">
              <app-status-badge [status]="service.effectiveStatus"></app-status-badge>
            </div>
          </article>
        }

        @if (services.length === 0) {
          <div class="empty-state">
            <div class="empty-icon">
              <span class="e-icons icon-checkmark"></span>
            </div>
            <p>{{ 'i18n.domain.status-dashboard.no-services' | translate }}</p>
          </div>
        }
      </div>
    </div>
  }
</div>
